//@ts-nocheck

import React from 'react'

import { Col, SpacerBase, Flex } from '../../../atoms/GridSystem'
import Button from '../../../atoms/Button/Button.component'
import Icon from '../../../atoms/Icon/Icon.component'
import { Paragraph } from '../../../atoms/Typography/Typography.component'

import * as S from '../Accordion.styles'

const TwoColumns = ({
  id,
  refs,
  colorScheme,
  accordion,
  iconLeft,
  tabIndex,
  disabled,
  title,
  body,
  link,
  handleClick,
}) => {
  return (
    <S.BaseAccordion
      id={id}
      tabIndex={tabIndex}
      ref={refs.wrapper}
      disabled={disabled}
      role="region"
    >
      {/* Header */}
      <S.BaseHeader
        ref={refs.header}
        colorScheme={colorScheme}
        onClick={() => handleClick(accordion)}
        onKeyDown={(ev) => (ev.key === "Enter" || ev.key === " ") && handleClick(accordion)}
        ariaLabel={accordion.open ? 'Riduci' : 'Espandi'}
        aria-expanded={accordion.open}
        tabIndex={0}
      >
        {iconLeft ? (
          <S.BaseIconLeft>
            <Icon name={iconLeft} />
          </S.BaseIconLeft>
        ) : null}
        <S.BaseHeaderContent>
          {title ? <Paragraph typo="headingMD" content={title} /> : null}
        </S.BaseHeaderContent>
        <S.BaseToggle $open={accordion.open}>
          <span />
          <span />
        </S.BaseToggle>
      </S.BaseHeader>
      {/* Content */}
      <S.BaseContent
        ref={refs.content}
        $open={accordion.open}
        aria-hidden={!accordion.open}
      >
        <Col xs={12} lg={6} $offset={{xs: 0, lg: 6}} $direction="column" align="flex-start">
          <Paragraph typo="paragraphLG" as="div">
            {body}
          </Paragraph>
          {link ? (
           <>
             <SpacerBase xs={2} />
             <Flex
								justifyContent={'center'}
							>
								<Button {...link} variant="primary" />
							</Flex>
           </>
         ) : null}
        </Col>
      </S.BaseContent>
    </S.BaseAccordion>
  )
}

export default TwoColumns
